import {memoize} from '@servicenow/ui-internal';

const hasSeperator = memoize(value => value.indexOf('/') > 0, {profileName: 'hasSeperator'});

export default function isSelector(value) {
	return typeof value === 'string' && value[0] === '@' && hasSeperator(value);
}
